__turbopack_context__.v({
  "active": "MobileFormSelectView-module-scss-module__SGAIqW__active",
  "backIcon": "MobileFormSelectView-module-scss-module__SGAIqW__backIcon",
  "backWrapper": "MobileFormSelectView-module-scss-module__SGAIqW__backWrapper",
  "closeIcon": "MobileFormSelectView-module-scss-module__SGAIqW__closeIcon",
  "header": "MobileFormSelectView-module-scss-module__SGAIqW__header",
  "notFound": "MobileFormSelectView-module-scss-module__SGAIqW__notFound",
  "option": "MobileFormSelectView-module-scss-module__SGAIqW__option",
  "options": "MobileFormSelectView-module-scss-module__SGAIqW__options",
  "root": "MobileFormSelectView-module-scss-module__SGAIqW__root",
  "searchIcon": "MobileFormSelectView-module-scss-module__SGAIqW__searchIcon",
  "searchInput": "MobileFormSelectView-module-scss-module__SGAIqW__searchInput",
  "searchWrapper": "MobileFormSelectView-module-scss-module__SGAIqW__searchWrapper",
});
